import footerLogo from '../../../assets/footerLogo.webp'
import { FooterContainer } from './styles'

export default function Footer(){
  return(
    <FooterContainer>
    <img src={footerLogo} alt="Logo" width="100%" height="100%"/>
    </FooterContainer>
  )
}